import PropTypes from 'prop-types';
import { Box, Button, CardContent, Typography } from '@mui/material';

import i18n from '@/i18n'

import {
  StyledCard,
  SectionHeader,
  SectionTitle,
  FilterTab,
} from './DashboardStyles';
import { PitchCard } from './PitchCard';
import { HBox } from '@/components/HBox';

const DATE_FILTERS = [
  {
    id: 'all',
    name: 'All',
    start: () => moment().subtract(1, 'month').format('YYYY-MM-DD'),
    end: () => moment().format('YYYY-MM-DD'),
  },
  {
    id: 'this-week',
    name: 'This Week',
    start: () => moment().startOf('week').format('YYYY-MM-DD'),
    end: () => moment().endOf('week').format('YYYY-MM-DD'),
  },
  {
    id: 'next-week',
    name: 'Next Week',
    start: () => moment().add(1, 'week').startOf('week').format('YYYY-MM-DD'),
    end: () => moment().add(1, 'week').endOf('week').format('YYYY-MM-DD'),
  },
];

export function ReleasesSection({ pitches, p, onPageChange, activeDateFilter, onDateFilterChange }) {
  return (
    <StyledCard>
      <CardContent sx={{ padding: 0, '&:last-child': { paddingBottom: 0 } }}>
        <SectionHeader>
          <SectionTitle>Upcoming Releases</SectionTitle>
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {DATE_FILTERS.map((filter) => (
              <FilterTab
                key={filter.id}
                variant={activeDateFilter === filter.id ? 'contained' : 'outlined'}
                onClick={() => onDateFilterChange(filter)}
              >
                {filter.name}
              </FilterTab>
            ))}
          </Box>
        </SectionHeader>
        <Box>
          {pitches?.length > 0 ? pitches?.map((pitch, index) => (
            <PitchCard
              key={index}
              animationDelay={index * 0.1}
              {...pitch}
            />
          )) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <Typography>No releases found</Typography>
            </Box>
          )}
        </Box>
      </CardContent>
      <HBox
        sx={{ justifyContent: 'center' }}
      >
        {!isNaN(pitches.previousPageNumber) && (
          <Button
            variant="outlined"
            onClick={() => onPageChange(pitches.previousPageNumber)}
          >
            {i18n.t('previous')}
          </Button>
        )}
        <Button variant="outlined">
          {p}
        </Button>
        {!isNaN(pitches.nextPageNumber) && (
          <Button
            variant="outlined"
            onClick={() => onPageChange(pitches.nextPageNumber)}
          >
            {i18n.t('next')}
          </Button>
        )}
      </HBox>
    </StyledCard>
  );
}

ReleasesSection.propTypes = {
  pitches: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.shape({
        name: PropTypes.string.isRequired
      }),
      release: PropTypes.shape({
        name: PropTypes.string.isRequired,
        artists: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string.isRequired
          })
        ).isRequired,
        released: PropTypes.string.isRequired,
        playlist: PropTypes.string.isRequired,
        genre: PropTypes.string.isRequired,
      }),
      source: PropTypes.oneOf(['focus', 'internal', 'external']),
      status: PropTypes.oneOf(['pending', 'submitted', 'focus']).isRequired,
    })
  ).isRequired,
  activeFilter: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func.isRequired,
};
